<template>
  <div class="publishRuleConfigWrap bj">
    <div class="title">
      <el-button
        type="primary"
        icon="el-icon-refresh"
        class="bjsearch"
        @click="Refresh"
      ></el-button>

      <el-button type="primary" @click="onHandleTag()">新增属性</el-button>
      <span v-if="showName" class="showNameWrap"
        >当前所属品类【{{ showName }}】</span
      >
    </div>
    <div class="auto-table-flex">
      <el-table
        :data="listData"
        v-loading="loading"
        height="100%"
        :border="true"
        :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
        ref="multipleTable"
        style="width: 100%"
      >
        <el-table-column type="index" width="100px" align="center" label="序号">
        </el-table-column>
        <el-table-column prop="field_key" align="center" label="属性名称">
        </el-table-column>
        <el-table-column prop="is_must_txt" align="center" label="是否必填">
        </el-table-column>
        <el-table-column prop="is_show" align="center" label="是否显示隐藏">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.value"
              active-color="#409EFF"
              inactive-color="#C0CCDA"
              @change="changeShow(scope.row)"
            >
            </el-switch>
          </template>
        </el-table-column>
           <el-table-column prop="is_searchable_txt" align="center" label="是否在分类页显示">
        </el-table-column>
        <el-table-column
          prop="product_edit_type_txt"
          align="center"
          label="是否可编辑"
        >
        </el-table-column>
        <el-table-column prop="purchase_parameter" align="center" label="排序">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="
                postAjaxCategoriesCustomFieldSort(scope.row, scope.$index, 1)
              "
              v-if="scope.$index != 0"
              >上移</el-button
            >
            <el-button
              type="text"
              @click="
                postAjaxCategoriesCustomFieldSort(scope.row, scope.$index, 2)
              "
              v-if="scope.$index != listData.length - 1"
              >下移</el-button
            >
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="scope">
            <el-button type="text" @click="onHandleviewProperties(scope.row)"
              >查看属性值</el-button
            >
            <el-button
              type="text"
              @click="onHandleTag(scope.row)"
              v-if="scope.row.system_type != 2"
              >编辑属性</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 新建编辑属性弹窗 start -->
    <add-attribute
      ref="addAttributeRef"
      @on-change="Refresh"
      :cidType="cidType"
    ></add-attribute>
    <!-- 新建编辑属性弹窗 end -->

    <!-- 查看属性弹窗 start -->
    <view-properties ref="viewPropertiesRef" @on-change="Refresh" />
    <!-- 查看属性弹窗 end -->
  </div>
</template>

<script>
import AddAttribute from "../modules/add-attribute/index.vue";
import ViewProperties from "../modules/view-properties/index.vue";
import {
  postCategoriesCustomFieldList,
  postCategoriesCustomFieldStatus,
  postCategoriesCustomFieldSort,
} from "@/api/generalControl/key-attributes.js";
export default {
  name: "publishRuleConfig",
  components: { AddAttribute, ViewProperties },
  data() {
    return {
      cid: "",
      cidType: "",
      listData: [], // 列表
      loading: false, // 表格加载
      showName: "",
    };
  },
  created() {
    this.cid = Number(this.$route.query.id);
    this.cidType = Number(this.$route.query.cidType);
    this.showName = this.$route.query.name ? this.$route.query.name : "";
    this.postAjaxCategoriesCustomFieldList();
  },
  mounted() {},
  methods: {
    // 属性列表
    async postAjaxCategoriesCustomFieldList() {
      this.loading = true;
      try {
        const res = await postCategoriesCustomFieldList({
          cid: this.cid,
        });
        this.listData = res.data;
        this.listData.forEach((item) => {
          if (item.is_show == 1) {
            item.value = true;
          } else {
            item.value = false;
          }
        });
      } catch (error) {
        console.log(error, "postCategoriesCustomFieldList");
      } finally {
        this.loading = false;
      }
    },
    // 修改显示/隐藏
    changeShow(e) {
      this.postAjaxCategoriesCustomFieldStatus(e);
    },
    // 变更显示隐藏状态
    async postAjaxCategoriesCustomFieldStatus(e) {
      try {
        const res = await postCategoriesCustomFieldStatus({
          id: e.id,
          is_show: e.value ? 1 : 0,
        });
        this.postAjaxCategoriesCustomFieldList();
      } catch (error) {
        console.log(error, "postAjaxCategoriesCustomFieldStatus");
      }
    },
    // 上移/下移动
    async postAjaxCategoriesCustomFieldSort(e, index, type) {
      try {
        const res = await postCategoriesCustomFieldSort({
          cid: this.cid,
          first_id: this.listData[index].id,
          last_id:
            type == 1
              ? this.listData[index - 1].id
              : this.listData[index + 1].id,
        });
        this.postAjaxCategoriesCustomFieldList();
        console.log(res, "res");
      } catch (error) {
        console.log(error, "postCategoriesCustomFieldSort");
      }
    },
    // 查看属性
    onHandleviewProperties(row) {
      this.$refs.viewPropertiesRef.onInitData(row);
    },
    /**
     * 新建/编辑属性
     */
    onHandleTag(row) {
      if (!row) {
        this.$refs.addAttributeRef.onInitData(this.cid);
        return;
      } else {
        this.$refs.addAttributeRef.onInitData(this.cid, row);
      }
    },
    // 刷新
    Refresh() {
      this.postAjaxCategoriesCustomFieldList();
    },
  },
};
</script>

<style lang="scss">
.publishRuleConfigWrap {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
  box-sizing: border-box;
  //   background: #ffffff;
  padding: 10px;
  .hide {
    .el-upload--picture-card {
      display: none;
    }
  }
  .title {
    background: #ffffff;
    padding: 13px 15px;
    box-sizing: border-box;
    display: flex;
    .seach {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      .inputs {
        width: 207px;
        margin-right: 8px;
      }
    }
    .bjsearch {
      background: #333333;
      border-color: #333333;
    }
  }

  .auto-table-flex {
    flex-grow: 1;
    overflow-y: hidden;
  }
  .fy {
    // background-color: #000;
    box-sizing: border-box;
    padding: 10px 20px;
  }
  .contents {
    padding-left: 55px;
    padding-right: 55px;
    padding-top: 23px;

    box-sizing: border-box;
    .titlname {
      font-size: 17px;
      color: #21c2ac;
      margin-bottom: 25px;
    }
    .imgs {
      display: flex;
      .imglist {
        width: 165px;
        height: 123px;
        border: 1px dashed #a4adc5;
        padding: 14px 8px;
        text-align: center;
        border-radius: 7px;
        box-sizing: border-box;
        margin-right: 16px;
        .div {
          margin-top: 20px;
          padding-bottom: 20px;
        }
        // img{
        //     width: 100%;
        //     height: 100%;
        // }
      }
    }
    .disply {
      display: flex;
      margin-bottom: 22px;
    }
    .mr {
      margin-right: 31px;
    }
    .iteminput {
      display: flex;
      align-items: center;

      .wen {
        width: 77px;
        margin-right: 24px;
        color: #000;
        font-size: 14px;
        text-align: right;
      }
      .el-input {
        width: 302px;
      }
    }
  }
}
.colors {
  color: #fa884c;
}
.times {
  margin-right: 8px;
}
// .el-picker-panel {
//   left: 1245px !important;
// }

.logistic-select_wrap {
  // height: 36px;
  // .el-input {
  //   height: 100%;
  // }
}
/** 标签样式 */
$tag-color: #545454;
$color: #13ae67;
.tag-wrap {
  display: flex;
  justify-content: center;
  //   gap: 5px;
  .tag-box {
    // max-width: 200px;
    // height: 35px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 5px;
    // overflow: hidden;
  }
  .tag {
    // height: 100%;
    line-height: 26px;
    padding: 3px 5px;
    border: 0.5px solid rgba($tag-color, 0.3);
    box-sizing: border-box;
    border-radius: 5px;
    color: $tag-color;
    background-color: rgba($tag-color, 0.1);
  }
  .icon {
    padding: 5px;
    border-radius: 5px;
    color: $color;
    cursor: pointer;
  }
}
.showNameWrap {
  color: #13ae67;
  font-size: 14px;
  font-weight: 500;
  margin-left: 20px;
  display: flex;
  align-items: center;
}
</style>
